var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "step-form",
      attrs: {
        visible: _vm.showModal,
        title: _vm.$t.__("preferences.Dunning.StepForm.add_dunning")
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: _vm.handleClose
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "dialog__default" }, [
          _c(
            "section",
            [
              _c("h3", { staticClass: "mb-4" }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__("Paramètres de votre relance automatique")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "stepForm",
                  attrs: {
                    labelPosition: "top",
                    model: _vm.step,
                    inlineMessage: true,
                    inline: false,
                    labelWidth: "120px"
                  }
                },
                [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$l10n.__("Titre de votre relance")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name", error: _vm.errors.get("name") } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.step.name },
                        model: {
                          value: _vm.step.name,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "name", $$v)
                          },
                          expression: "step.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.$l10n.__("Délai d'envoi")))]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t.__(
                          "preferences.Dunning.StepForm.define_day_number_before_due_date"
                        ),
                        prop: "days",
                        error: _vm.errors.get("days")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "custom-width-select",
                          model: {
                            value: _vm.step.days,
                            callback: function($$v) {
                              _vm.$set(_vm.step, "days", $$v)
                            },
                            expression: "step.days"
                          }
                        },
                        _vm._l(_vm.daysList, function(daysSelect) {
                          return _c("el-option", {
                            key: daysSelect.numberOfDay,
                            attrs: {
                              label: daysSelect.label,
                              value: daysSelect.numberOfDay
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$l10n.__("Paramètres de l’email")))
                  ]),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$l10n.__("Expéditeur de l'email")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t.__(
                          "preferences.Dunning.StepForm.define_staff_sending_email"
                        ),
                        prop: "senderType",
                        error: _vm.errors.get("sender_type")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          model: {
                            value: _vm.step.senderType,
                            callback: function($$v) {
                              _vm.$set(_vm.step, "senderType", $$v)
                            },
                            expression: "step.senderType"
                          }
                        },
                        _vm._l(_vm.senderTypeList, function(sender) {
                          return _c("el-option", {
                            key: sender.code,
                            attrs: { label: sender.label, value: sender.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.step.senderType == "staff"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t.__(
                              "preferences.Dunning.StepForm.select_staff_sending_email"
                            ),
                            prop: "senderId",
                            error: _vm.errors.get("sender_id")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                filterable: "",
                                remote: "",
                                reserveKeyword: "",
                                remoteMethod: _vm.autoCompleteStaff,
                                loading: _vm.loading
                              },
                              model: {
                                value: _vm.step.senderId,
                                callback: function($$v) {
                                  _vm.$set(_vm.step, "senderId", $$v)
                                },
                                expression: "step.senderId"
                              }
                            },
                            _vm._l(_vm.staff, function(email) {
                              return _c("el-option", {
                                key: email.id,
                                attrs: { label: email.label, value: email.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$l10n.__("Destinataire de l'email")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t.__(
                          "preferences.Dunning.StepForm.determine_recipient_contact"
                        ),
                        prop: "recipientType",
                        error: _vm.errors.get("recipient_type")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          model: {
                            value: _vm.step.recipientType,
                            callback: function($$v) {
                              _vm.$set(_vm.step, "recipientType", $$v)
                            },
                            expression: "step.recipientType"
                          }
                        },
                        _vm._l(_vm.recipientTypeList, function(recipient) {
                          return _c("el-option", {
                            key: recipient.code,
                            attrs: {
                              label: recipient.label,
                              value: recipient.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.step.recipientType == "staff"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "recipientId",
                            error: _vm.errors.get("recipient_id")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                filterable: "",
                                remote: "",
                                reserveKeyword: "",
                                remoteMethod: _vm.autoCompleteStaff,
                                loading: _vm.loading
                              },
                              model: {
                                value: _vm.step.recipientId,
                                callback: function($$v) {
                                  _vm.$set(_vm.step, "recipientId", $$v)
                                },
                                expression: "step.recipientId"
                              }
                            },
                            _vm._l(_vm.staff, function(email) {
                              return _c("el-option", {
                                key: email.id,
                                attrs: { label: email.label, value: email.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.$l10n.__("Email envoyé")))]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t.__(
                          "preferences.Dunning.StepForm.choose_email_send_during_reminber"
                        ),
                        prop: "emailTemplateId",
                        error: _vm.errors.get("email_templates_custom_id")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          model: {
                            value: _vm.step.emailTemplateId,
                            callback: function($$v) {
                              _vm.$set(_vm.step, "emailTemplateId", $$v)
                            },
                            expression: "step.emailTemplateId"
                          }
                        },
                        _vm._l(_vm.emailTemplate, function(emailSelect) {
                          return _c("el-option", {
                            key: emailSelect.id,
                            attrs: {
                              label: emailSelect.name,
                              value: emailSelect.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-4 mb-5" },
                [
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$l10n.__("Visualisation de l'email")) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("custom-mail-preview", {
                    attrs: { id: _vm.step.emailTemplateId }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: { click: _vm.handleClose }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: {
                label: _vm.$t.__("preferences.Dunning.StepForm.reset_values"),
                type: "secondary"
              },
              on: {
                click: function($event) {
                  return _vm.reset()
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: { label: _vm.$t.__("common.actions.save") },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }